import React, { useState, useEffect} from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import DetailIcon from '../../components/Table/DetailIcon/DetailIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/PopupCommon/Popupcommon.css';
import '../../components/PopupCommon/EditSecond.css';
import '../../components/PopupCommon/ExchangeHistory.css';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import useFilterStore from '../../store/useFilterStore';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
import TaxPopup from '../../components/Popup/Individual Popup/TaxPopUp';
import * as taxService from '../../services/Localization/TaxService';
const pageKey = "faqcategory"

const Taxes = () => {
    const { setFilters, getFilters } = useFilterStore();
    const savedFilters = getFilters(pageKey);
    const [items, setItems] = useState([]);
    const [mode, setMode] = useState([]);
    const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState([]);
    const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
    const searchCategories = ['Tax','Country'];
    const filterOptions = ['Default', 'Archived', 'Unarchived'];
    const [popupError, setPopupError] = useState('');
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
    const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
    const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
    const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);  
    const { refreshKeys } = useRefreshStore();
    const refreshKey = refreshKeys["Taxes"] || 0;
 
  const fetchTaxes = async () => {
      try {
        const data = await taxService.fetchTaxes({ 
          searchParams, 
          selectedFilterOption, 
          selectedSortOption: mapSortOptionToQuery(selectedSortOption)
        });
        if (data.response_code === 1 && Array.isArray(data.data)) {
          setItems(data.data);
        } else {
          setItems([]);
        }
      } catch (error) {
        console.error(error);
        setItems([]);
      }
  };
      
  useEffect(() => {
      fetchTaxes();
      setFilters(pageKey, {
        searchParams,
        selectedFilterOption,
        selectedSortOption,
    });
  }, [searchParams, selectedFilterOption, selectedSortOption]);


    useEffect(() => {
        fetchTaxes();
    }, [refreshKey]);

  const handleAddTax = async (formValues) => {
    try {
      const data = await taxService.addTax(formValues);
      if (data.response_code === 1) {
        await fetchTaxes();
        closePopups();
      } else {
        setPopupError(data.message || 'Something went wrong!');
      }
    } catch {
      setPopupError('Failed to add tax. Please try again.');
    }
  };
      
  const handleEditTax = async (formValues) => {
    try {
      const data = await taxService.editTax(selectedItem.id, formValues);
      if (data.response_code === 1) {
        await fetchTaxes(); 
        closePopups();
      } else {
        setPopupError(data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to edit tax. Please try again.');
    }
  };


  const handleDeleteTax = async () => {
    try {
      const response = await taxService.deleteTax(selectedItem.id);
      if (response.status >= 200 && response.status < 300) {
        fetchTaxes();  
        setIsDeletePopupOpen(false);
      } else {
        throw new Error('Failed to delete tax');
      }
    } catch (error) {
      console.error(error);
    }
  };


  const handleArchiveSelectedTaxes = async () => {
    try {
      const response = await taxService.archiveSelectedTaxes(selectedItems);
      if (response.status >= 200 && response.status < 300) {
        fetchTaxes();
        resetCheckboxState();
        closePopups();
      } else {
        console.error('Failed to archive/unarchive selected taxes');
      }
    } catch (error) {
      console.error(error);
    }
  };


  const handleArchiveTax = async () => {
    try {
      const response = await taxService.archiveTax(selectedItem.id);
      if (response.status >= 200 && response.status < 300) {
        await fetchTaxes();
        closePopups();
      }
    } catch (error) {
      console.error(error);
    }
  };

    
  const handleSearchSelect = (searchCategory,searchTerm) => {
    setSearchParams({
      term: searchTerm,                   
      argument: searchCategory.toLowerCase(), 
    });
  };


    const mapSortOptionToQuery = (option) => {
      switch (option) {
        case 'A-Z':
          return 'a_to_z';
        case 'Z-A':
          return 'z_to_a';
        case 'Newest':
          return 'newest';
        case 'Oldest':
          return 'oldest';
        default:
          return 'newest';
      }
    };
    const handleSortOptionSelect = (option) => {
        setSelectedSortOption(option); 

    };
    const handleFilterSelect = (option) => {
      setSelectedFilterOption(option);

    };

    const handleArchiveClick = async (item) => {
      setSelectedItem(item);
      setIsArchivePopupOpen(true);
    };

    const handleAddClick = () => {
        setSelectedItem([]);
        setMode("add")
        setPopupOpen(true);
    };

      
    const handleEditClick = (tax) => {
      setSelectedItem(tax);
      setMode("edit")
      setPopupOpen(true);
    };
  
    const handleDeleteClick = async (item) => {
      setSelectedItem(item);
      setIsDeletePopupOpen(true);
    };

    const handleDetailClick = (item) => {
        setSelectedItem(item);
        setMode("detail")
        setPopupOpen(true);
    };

    const deletePopupFields = [
      { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
    ];    

    const closePopups = () => {
        setIsArchivePopupOpen(false);
        setPopupOpen(false);
        setMode([])
        setPopupError('');
        setSelectedItem([])
    };

  const handleExportComplete = () => {
    resetCheckboxState();
  };


    return (
        <div className='whole-container'>
            <div className='top-heading'>
                <PageHeader pageName=" Localization /" nestedpageName="Taxes"  linkTo="" />
                <div className='export-container'>
                  <ArchiveSelectedItem
                    selectedItems={selectedItems}
                    items={items}
                    onArchiveSelected={handleArchiveSelectedTaxes}
                  />
                  <ExportLabel
                    exportUrl={`${baseurl}tax/export/`}
                    selectedIds={selectedItems}
                    onExportComplete={handleExportComplete}
                  />
                </div>
            </div>
            <div className='pagename-container'>
                <div className='page-name'>
                    <h1 className='common-text fts-22 ftw-6 blue'>Taxes</h1>
                </div>
                <div className='pagename-right-container'>
                    <AddButton onClick={handleAddClick} />
                    <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
                    <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
                    <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
                </div>
            </div>
            <div className='table-container'>
                <table className='common-table'>
                    <thead className='common-table-head'>
                        <tr className='common-table-thead-tr'>
                            <th>
                                <input
                                  className="table-selectbox table-parent-selectbox"
                                  type="checkbox"
                                  checked={isParentSelected}
                                  onChange={handleParentCheckboxChange}
                                />Tax Name
                            </th>
                            <th>Tax Computation</th>
                            <th>Tax Type</th>
                            <th>Tax Rate</th>
                            <th>Tax Scope</th>
                            <th>Country</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody className='common-table-tbody'>
                    {items.length > 0 ? (
                        items.map((tax) => (
                        <tr key={tax.id} className={tax.is_archived ? 'archived-item' : ''}>                          
                            <td className='d-flex ai-center'>
                              <input
                                className="table-selectbox table-child-selectbox"
                                type="checkbox"
                                checked={selectedItems.includes(tax.id)}
                                onChange={() => handleChildCheckboxChange(tax.id)}
                              />{tax.name}
                            </td>   
                  
                            <td>{tax.tax_computation_display || 'N/A'}</td>
                            <td>{tax.tax_type_display || 'N/A'}</td>
                            <td>{tax.tax_rate}</td>
                            <td>{tax.tax_scope_display || 'N/A'}</td>

                            <td>{tax.country?.name || 'Unknown Country'}</td>
                            <td className="actions common-action">
                              <DetailIcon onClick={() => handleDetailClick(tax)} />
                              <EditIcon onClick={() => handleEditClick(tax)} />
                              <ArchiveIcon onClick={() => handleArchiveClick(tax)} isArchived={tax.is_archived} /> 
                              <DeleteIcon onClick={() => handleDeleteClick(tax)} />                                                        
                            </td>
                        </tr>
                        ))
                        ) : (
                            <tr>
                              <td colSpan="6">No taxes available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <ArchivePopup
              isOpen={isArchivePopupOpen}
              isArchived={selectedItem?.is_archived}
              archivename={selectedItem?.name }
              onSave={handleArchiveTax}
              onClose={() => setIsArchivePopupOpen(false)}
            />
            <DeletePopup
              isOpen={isDeletePopupOpen}
              title="Delete Taxes"
              fields={deletePopupFields}
              onSave={handleDeleteTax}
              onClose={closePopups}
            /> 
            <TaxPopup
                isOpen={isPopupOpen}
                mode={mode}
                buttonName={mode === 'add' ? 'Add Tax' : 'Save'}
                defaultValue={selectedItem}
                onSave={mode === 'add' ? handleAddTax : handleEditTax}
                onClose={closePopups}
                popupErrorMessage={popupError}
            />
        </div>
    );
};

export default Taxes;
